// extracted by mini-css-extract-plugin
export default {"errorMessage":"NotesContainer_errorMessage__0RKpN","newNoteInput":"NotesContainer_newNoteInput__LAZgN","notesContainer":"NotesContainer_notesContainer__Hx44a"};